import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'libs/styled';
import { above } from '@sportson/core-web/utils/mediaqueries';
import CoreButton from '@grebban/react-core-components/Button';
import GalleryThumbnail from './GalleryThumbnail';

const GalleryThumbnailsWrapper = styled('div')`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    width: 100%;
`;

const Button = styled(CoreButton)`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    height: 48px;

    ${above['tablet.sm']} {
        height: 64px;
    }

    aspect-ratio: 1;
    border: 1px solid transparent;
    border-radius: 4px;

    border: 1px solid var(--color-neutrals-300);
    background-color: var(--color-neutrals-100);

    ${({ active }) => active && 'border: 1px solid var(--color-base-black);'}

    img {
        mix-blend-mode: multiply;
    }
`;

const GalleryThumbnails = ({ activeIndex, media = [], onClick }) => {
    const { t } = useTranslation();
    const onButtonClick = useCallback((index, media) => {
        onClick && onClick(index, media);
    });

    return (
        <GalleryThumbnailsWrapper
            backgroundColor={['var(--color-base-white)', null, null, 'var(--color-neutrals-100)']}
            p={['12px 12px 0', null, '12px 24px 0', '16px']}
        >
            {media.map((media, index) => (
                <Button
                    key={`pdp-thumbnail-${index}-${media.image}`}
                    active={index === activeIndex}
                    data-full-size={media.isFullSize}
                    data-index={index}
                    onClick={() => onButtonClick(index, media)}
                    aria-label={t('pdp.gallery.image_x_of_y', { current: index, total: media.length })}
                >
                    <GalleryThumbnail media={media} />
                </Button>
            ))}
        </GalleryThumbnailsWrapper>
    );
};

GalleryThumbnails.propTypes = {
    media: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            video: PropTypes.string,
            youtube: PropTypes.string,
            image: PropTypes.string,
        }),
    ).isRequired,
};

export default GalleryThumbnails;
